var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lbv-leak-list animated fadeIn roundedCard" },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-12" },
          [
            _c(
              "b-card",
              [
                _c("div", { staticClass: "col-lg-12 leak-list-header" }, [
                  _c("span", { staticClass: "lbv-page-title" }, [
                    _vm._v("Incomplete Installs"),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row secondary lbv-search" }, [
                  _c(
                    "form",
                    {
                      staticClass: "lbv-search-filter w-100 mx-3",
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                          return _vm.search.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        { staticClass: "w-100 d-flex align-items-center" },
                        [
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Search Type",
                                    "label-for": "search-type",
                                  },
                                },
                                [
                                  _c(
                                    "b-input-group",
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "search-type",
                                          options: _vm.searchType,
                                        },
                                        on: {
                                          input:
                                            _vm.fetchIncompleteInstallsListData,
                                        },
                                        nativeOn: {
                                          change: function ($event) {
                                            return _vm.onChange.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.typeSearch,
                                          callback: function ($$v) {
                                            _vm.typeSearch = $$v
                                          },
                                          expression: "typeSearch",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: {
                                    label: "Search",
                                    "label-for": "search",
                                  },
                                },
                                [
                                  _c("b-input-group", [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.searchInput,
                                          expression: "searchInput",
                                        },
                                      ],
                                      staticClass: "form-control full-width",
                                      attrs: {
                                        id: "search",
                                        type: "text",
                                        placeholder: "",
                                      },
                                      domProps: { value: _vm.searchInput },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.searchInput = $event.target.value
                                        },
                                      },
                                    }),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            [
                              _c(
                                "b-form-group",
                                {
                                  attrs: { label: "Rows", "label-for": "rows" },
                                },
                                [
                                  _c(
                                    "b-input-group",
                                    [
                                      _c("b-form-select", {
                                        attrs: {
                                          id: "rows",
                                          options: _vm.pageOptions,
                                        },
                                        model: {
                                          value: _vm.perPage,
                                          callback: function ($$v) {
                                            _vm.perPage = $$v
                                          },
                                          expression: "perPage",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-col",
                            {
                              staticClass: "d-flex align-items-center",
                              attrs: { cols: "4" },
                            },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "w-100 mr-3",
                                  attrs: {
                                    id: "applyBtn",
                                    variant: "primary",
                                    type: "submit",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                  Apply\n                "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "w-100",
                                  attrs: { id: "applyBtn", variant: "primary" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.downloadReport.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("span", { staticClass: "download" }, [
                                    _vm._v("Export CSV File"),
                                  ]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "b-modal",
                  {
                    ref: "markAsDisabledUserDetails",
                    attrs: {
                      id: "mark-as-disabled",
                      title: "Incomplete Install - Mark As Disabled",
                      "ok-variant": "primary",
                      "ok-title": "Ok",
                    },
                    on: { ok: _vm.markAsDisabled },
                  },
                  [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c("h6", { staticClass: "text-center" }, [
                        _vm._v(
                          "\n              Are you sure you want to change the User details to "
                        ),
                        _c("b", [_vm._v(_vm._s(_vm.selectedUser.username))]),
                        _vm._v("?\n            "),
                      ]),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-alert",
                  { attrs: { show: _vm.errorString != "", variant: "danger" } },
                  [
                    _vm._v(
                      "\n          " + _vm._s(_vm.errorString) + "\n        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c("b-table", {
                  attrs: {
                    responsive: "",
                    striped: "",
                    hover: "",
                    items: _vm.incompleteInstallsList,
                    fields: _vm.fields,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "address_1postCode",
                      fn: function (data) {
                        return [
                          _vm._v(
                            "\n            " +
                              _vm._s(data.item.address_1) +
                              ", " +
                              _vm._s(data.item.postCode) +
                              "\n          "
                          ),
                        ]
                      },
                    },
                    {
                      key: "action",
                      fn: function (data) {
                        return [
                          _c(
                            "b-link",
                            {
                              staticClass: "deviceLink",
                              on: {
                                click: function ($event) {
                                  return _vm.showUserDetails(data)
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n              Mark as disabled\n            "
                              ),
                            ]
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "page prev",
                    attrs: {
                      variant: "primary",
                      size: "sm",
                      disabled: _vm.pageNumber === 1,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.page.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n          Prev\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    staticClass: "page next",
                    attrs: {
                      variant: "primary",
                      size: "sm",
                      disabled: !_vm.hasNextPage,
                    },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.page.apply(null, arguments)
                      },
                    },
                  },
                  [_vm._v("\n          Next\n        ")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "current-page" }, [
                  _vm._v(
                    "\n          Page: " + _vm._s(_vm.pageNumber) + "\n        "
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }